import React from "react";
import "./Footer.css";
// import { logo_name } from "../../assets";

export default function Footer() {
  return (
    <div className="footer">
      <div>
        <img
          src={"https://i.imgur.com/LQ0Sq4z.png"}
          alt="brand logo"
          width={400}
        />
      </div>
      <p>
        @ {new Date().getFullYear()} Killer Proxies LLC Dashboard by{" "}
        <a
          href="https://torchlabs.xyz/"
          style={{
            color: "white",
            fontWeight: 600,
            textDecoration: "none",
          }}
        >
          Torch Labs
        </a>
      </p>
    </div>
  );
}
